import { createSelector } from "reselect";
import _ from "lodash";
import LocationType from "../../../components/survey/create/SurveyStepActionsKpi/LocationType";
import { KPI_COM_END_LOCATION_ID, KPI_COM_END_VISIT_ID, STATEMENT_END_LOCATION_ID } from "../../../configs/constants";


/**
 * get kpisList
 * @param state
 * @param props
 * @return {*|Array}
 */
export const getKpisList = (state) => {
	const survey = state.survey || {};
	const surveyManager = survey.surveyManager || {};
	return surveyManager.kpisList || [];
};

/**
 * get actionTypes
 * @param state
 * @param props
 * @return {*|Array}
 */
export const getActionTypes = (state) => {
	const survey = state.survey || {};
	const surveyManager = survey.surveyManager || {};
	return surveyManager.actionTypes || [];
};

export const displayComVisit = createSelector(
	[getKpisList],
	kpisList => {
		const kpiIndex =_.findIndex(kpisList, {id:KPI_COM_END_VISIT_ID});
		return (kpiIndex !== -1);
	}
);

export const displayComLocation = createSelector(
	[getKpisList],
	kpisList => {
		const kpiIndex =_.findIndex(kpisList, {id:KPI_COM_END_LOCATION_ID});
		return (kpiIndex !== -1);
	}
);

/**
 * get locationTypes
 * @param state
 * @param props
 * @return {{}}
 */
const getCurrentLocationType = (state, props) => {
	const survey = state.survey || {};
	const surveyManager = survey.surveyManager || {};
	const surveyProgress = surveyManager.surveyProgress || {};
	const locationTypes = surveyProgress.locationTypes || [];
	const location = props.location || {};
	const locationTypeId = location.locationTypeId;
	const locationTypeDataIndex = _.findIndex(locationTypes, {
		locationTypeId: locationTypeId,
	});

	return locationTypeDataIndex !== -1
		? locationTypes[locationTypeDataIndex]
		: {};
};

export const makeIsComLocationChecked = () => {
	return createSelector(
		[getCurrentLocationType],
		locationType => {
			const locationTypeInstance = new LocationType(locationType);
			const statement = locationTypeInstance.getStatement(
				STATEMENT_END_LOCATION_ID + ""
			);
			return !!statement;
		}
	);
};

/**
 * Get end_visit_statement
 * @param state
 */
const getEndVisitStatement = state => {
	const survey = state.survey || {};
	const surveyManager = survey.surveyManager || {};
	const surveyProgress = surveyManager.surveyProgress || {};
	return surveyProgress.end_visit_statement || null;
};

export const makeIsComVisitChecked = () => {
	return createSelector(
		[getEndVisitStatement],
		endVisitStatement => {
			return !!endVisitStatement;
		}
	);
};



// WEBPACK FOOTER //
// src/redux/selectors/survey/createSelector.js